import { Route, Redirect } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { useLocation } from 'react-router-dom'
import { Button } from '@/shared/components/Button'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user, loading } = useAuth()
  const location = useLocation()
  
  if (loading) return <div>Carregando...</div>
  
  // Verifica se o usuário está autenticado
  if (!user) {
    return <Redirect to="/log_in" />
  }
  
  // Verifica se é usuário externo tentando acessar tela não autorizada
  if (user.isExternalUser) {
    const isPersonalizado = location.pathname.includes('/detalhesdisponibilidade/personalizado/');
    
    // Usuário externo só pode acessar telas personalizadas
    if (!isPersonalizado) {
      console.warn('🚫 Usuário externo tentando acessar tela restrita:', location.pathname);
      return (
        <div style={{ 
          padding: '50px', 
          textAlign: 'center',
          fontFamily: 'Arial, sans-serif',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f8f9fa'
        }}>
          <div style={{
            background: 'white',
            padding: '40px',
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            maxWidth: '500px'
          }}>
            <h2 style={{ color: '#dc3545', marginBottom: '20px' }}>🚫 Acesso Restrito</h2>
            <p style={{ marginBottom: '15px', color: '#6c757d' }}>
              Você está acessando como usuário externo e não tem permissão para esta área.
            </p>
            <p style={{ marginBottom: '25px', color: '#6c757d' }}>
              Para acessar todas as funcionalidades, faça login com sua conta @transben.com.br
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button 
                variant="primary" 
                onClick={() => window.location.href = '/log_in'}
                style={{ minWidth: '120px' }}
              >
                Fazer Login
              </Button>
              <Button 
                variant="secondary" 
                onClick={() => window.close()}
                style={{ minWidth: '120px' }}
              >
                Fechar
              </Button>
            </div>
          </div>
        </div>
      );
    }
  }
  
  return (
    <Route
      {...rest}
      render={props => <Component {...props} />}
    />
  )
}

export default PrivateRoute
